
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name
            }}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="题目类型：">
                <el-select style="width: 100px;" size="small" v-model="formInline.type" placeholder="请选择">
                    <el-option v-for="type in type" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="科目类别：">
                <el-select style="width: 100px;" size="small" v-model="formInline.subject" placeholder="请选择">
                    <el-option v-for="type in subject" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="题型：">
                <el-select style="width: 100px;" size="small" v-model="formInline.type_question" placeholder="请选择">
                    <el-option v-for="type in type_question" :label="type.key" :value="type.value"
                        :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="编号：">
                <el-input size="small" v-model="formInline.number" placeholder="请输入编号"></el-input>
            </el-form-item>
            <el-form-item label="题目：">
                <el-input size="small" v-model="formInline.title" placeholder="请输入题目"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="40">
            </el-table-column>
            <el-table-column prop="pbid" label="ID" width="60">
            </el-table-column>
            <el-table-column prop="type" label="题目类型" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.type == 0">小车</div>
                    <div v-else-if="row.type == 1">货车</div>
                    <div v-else-if="row.type == 2">客车</div>
                    <div v-else>摩托车</div>
                </template>
            </el-table-column>
            <el-table-column prop="number" label="编号" width="80">
            </el-table-column>
            <el-table-column prop="subject" label="科目类别" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.subject == 0">科目一</div>
                    <div v-else>科目四</div>
                </template>
            </el-table-column>
            <el-table-column prop="type_question" label="题型" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.type_question == 0">判断</div>
                    <div v-else-if="row.type_question == 1">单选</div>
                    <div v-else>多选</div>
                </template>
            </el-table-column>
            <el-table-column prop="title" label="题目" width="auto" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="title_img" label="题目图片" width="80" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="height: 24px;" v-if="scope.row.title_img" class="table_list_pic"
                            :src="scope.row.title_img" :preview-src-list="[scope.row.title_img]"></el-image>
                        <div v-else>暂无图片</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="opt" label="题目选项" width="auto" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="answer" label="题目答案" width="80">
            </el-table-column>
            <el-table-column prop="explain_official" label="官方讲解" width="auto" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="explain_skill" label="技巧讲解" width="auto" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="explain_skill_gif" label="技巧讲解图片" width="100">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="height: 24px;" v-if="scope.row.explain_skill_gif" class="table_list_pic"
                            :src="scope.row.explain_skill_gif" :preview-src-list="[scope.row.explain_skill_gif]"></el-image>
                        <div v-else>暂无图片</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="180">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="uptexts(scope.row)"><i
                            class="el-icon-edit" />题目修改</el-button>
                    <el-button size="mini" type="primary" @click="Uptaudio(scope.row)"><i
                            class="el-icon-edit" />语音修改</el-button>
                    <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <Uptext :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Uptext>
        <Uptaudio :info="updateInfos" :show.sync="dialog.uptaudioDialogStatus" size="small" @refesh_list="getdata"></Uptaudio>
        <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"></Add>
    </div>
</template>
  
<script>
import { getProblem, getedit,geteditVoice } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import Uptext from './uptext.vue'
import Add from './add.vue'
import Uptaudio from './uptaudio.vue'
export default {
    // 注册组件
    components: {
        Pagination, Uptext, Add,Uptaudio
    },
    data() {
        return {
            subject: [
                { key: '请选择', value: '' },
                { key: '科目一', value: 0 },
                { key: '科目四', value: 3 },
            ],
            type: [
                { key: '请选择', value: '' },
                { key: '小车', value: 0 },
                { key: '货车', value: 1 },
                { key: '客车', value: 2 },
                { key: '摩托车', value: 3 },
            ],
            type_question: [
                { key: '请选择', value: '' },
                { key: '判断', value: 0 },
                { key: '单选', value: 1 },
                { key: '多选', value: 2 },
            ],
            dialog: {
                addDialogStatus: false,
                updateDialogStatus: false,
                uptaudioDialogStatus: false

            },
            breadcrumbList: [],
            updateInfo: {},
            updateInfos:{},
            loading: false, //是显示加载
            formInline: {
                title: '',
                number: '',
                subject: '',
                type_question: '',
                type: '',
                limit: 10,
                page: 1
            },
            listData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    mounted(){
        this.getdata()
        this.generateBreadcrumb()
    },
    watch: {
        $route() {
            this.generateBreadcrumb()
        }
    },
    methods: {
        //添加题目
        add() {
            console.log(1111);
            this.dialog.addDialogStatus = true
        },
        //修改题目
        uptexts(row) {
            getedit({ pbid: row.pbid, echo: 'get' }).then(res => {
                console.log(res,'+++++++++++');
                if (res.code == 200) {
                    this.dialog.updateDialogStatus = true
                    this.updateInfo = res.bank_info
                }
            })
        },
        //修改语音
        Uptaudio(row){
            geteditVoice({ pbid: row.pbid}).then(res => {
                if (res.code == 200) {
                    this.dialog.uptaudioDialogStatus = true
                    this.updateInfos = res.bank_info
                }
            })
        },
        search() {
            this.formInline.page = 1
            this.getdata(this.formInline)
        },
        generateBreadcrumb() {
            // 获取当前路由信息
            const matched = this.$route.matched
            console.log(matched, '++++++++++');
            // 初始化面包屑导航数据
            const breadcrumbList = []
            // 遍历路由信息，生成面包屑导航数据
            matched.forEach(item => {
                const { meta, name, path } = item
                if (meta.requireAuth) {
                    breadcrumbList.push({
                        name,
                        path
                    })
                }
            })
            console.log(breadcrumbList, '=========');
            // 保存面包屑导航数据
            this.breadcrumbList = breadcrumbList
        },
        getdata() {
            console.log('执行了');
            this.loading = true
            getProblem(this.formInline).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.listData = res.problem_info.data
                    this.pageparm.total = res.problem_info.total
                    this.loading = false

                }
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
  
<style scoped>
.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/topic/index.vue